export const inputType = {type: 'html-file' as const};
